import React from 'react'

import { FilterTypeSort } from '@/components/filters/types/FilterTypeSort'
import { FilterTypeDropdown } from '@/components/filters/types/FilterTypeDropdown'
import { FilterTypeMultiSelect } from '@/components/filters/types/FilterTypeMultiSelect'
import { COACHING_INBOX, COMPLIANCE_INBOX, QA_INBOX } from '@/reducers/tasks/tasks.constants'

import {
  AGENT_FILTER_INBOXES,
  taskAgentReviewedOptions,
  taskTypeOptions,
  getSortByOptions,
  qaTypeOptions,
} from '../inbox.helpers'

export const InboxFilters = ({
  isArchive,
  inboxType,
  sortConfig,
  setSortConfig,
  taskStatus,
  taskCreatedBy,
  taskAgentReviewed,
  taskType,
  agentOptions,
  agentsLoading,
  selectedAgents,
  setSelectedAgents,
  complianceType,
  setTaskStatus,
  setTaskCreatedBy,
  setTaskAgentReviewed,
  setTaskType,
  setComplianceType,
  complianceTypeOptions,
}) => {
  const sortByOptions = getSortByOptions(inboxType)

  return (
    <div className="flex-align-start medium-gap">
      <FilterTypeSort
        label="Sort By"
        options={sortByOptions}
        sortConfig={sortConfig}
        updateSortConfig={(updatedSortConfig) => {
          setSortConfig(updatedSortConfig)
        }}
        data-testid="inbox-sort-by"
      />
      {isArchive && (
        <>
          <FilterTypeDropdown
            data-testid="inbox-status-filter"
            schema={{ accessor: 'status', label: 'Status', options: taskTypeOptions }}
            value={taskStatus}
            updateSearch={(accessor, updatedValue) => {
              setTaskStatus(updatedValue)
            }}
            showAllOnEmpty
            showAllOnEmptyLabel="All"
            isClearable={!!taskStatus}
          />
          {inboxType === COACHING_INBOX && (
            <FilterTypeDropdown
              data-testid="inbox-agent-acknowledged-filter"
              schema={{
                accessor: 'acknowledged',
                label: 'Agent Acknowledged',
                options: taskAgentReviewedOptions,
              }}
              value={taskAgentReviewed}
              updateSearch={(accessor, updatedValue) => {
                setTaskAgentReviewed(updatedValue)
              }}
              showAllOnEmpty
              showAllOnEmptyLabel="All"
              isClearable={!!taskAgentReviewed}
            />
          )}
        </>
      )}
      {inboxType !== QA_INBOX && (
        <FilterTypeDropdown
          data-testid="inbox-created-by-filter"
          schema={{
            accessor: 'created_by',
            label: 'Created By',
            options: [{ value: 'my', label: 'Me' }],
          }}
          value={taskCreatedBy}
          updateSearch={(accessor, updatedValue) => {
            setTaskCreatedBy(updatedValue)
          }}
          showAllOnEmpty
          showAllOnEmptyLabel="All"
          isClearable={!!taskCreatedBy}
        />
      )}
      {inboxType === QA_INBOX && (
        <FilterTypeDropdown
          schema={{ accessor: 'taskType', label: 'Type', options: qaTypeOptions }}
          value={taskType}
          updateSearch={(accessor, updatedValue) => {
            setTaskType(updatedValue)
          }}
          showAllOnEmpty
          showAllOnEmptyLabel="All"
          isClearable={!!taskType}
        />
      )}
      {inboxType === COMPLIANCE_INBOX && (
        <FilterTypeDropdown
          schema={{ accessor: 'complianceType', label: 'Type', options: complianceTypeOptions }}
          value={complianceType}
          // Compliance type values are their own labels, so display the applied
          // value directly — the pill stays truthful (and clearable) even if the
          // selected type drops out of the backend-provided options.
          format={() => complianceType}
          updateSearch={(accessor, updatedValue) => {
            setComplianceType(updatedValue)
          }}
          showAllOnEmpty
          showAllOnEmptyLabel="All"
          isClearable={!!complianceType}
        />
      )}
      {AGENT_FILTER_INBOXES.includes(inboxType) && (
        <FilterTypeMultiSelect
          schema={{ accessor: 'agents', label: 'Agents', options: agentOptions }}
          value={selectedAgents}
          loading={agentsLoading}
          updateSearch={(accessor, updatedAgents) => {
            setSelectedAgents(updatedAgents)
          }}
        />
      )}
    </div>
  )
}
